import { oneOf } from 'prop-types';

export const buttonTypePropType = oneOf(['button', 'submit', 'reset']);
